<h1 mat-dialog-title>Edición de médico derivante</h1>
<div mat-dialog-content>
    <app-referring-physician-edit-component [referringPhysicianId]="referringPhysicianId" (onClose)="onClose($event)"></app-referring-physician-edit-component>
</div>